import React, { useState, useEffect, useRef } from "react";

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Tooltip from "@material-ui/core/Tooltip";
import { API_URL, API_VERSION } from "../../../../../ApiUrl";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import classnames from "classnames";
import tingtong from "../../../../../assets/images/ting-tong.gif";
import Checkbox from "./checkbox";

import {
  Link,
  ApiUrl,
  Axios,
  DialogBox,
  Row,
  Col,
  SELECT,
  toast,
  Loading,
  moment,
  Card,
  CardBody,
  CardText,
  DataTablePagination,
} from "../../../../../components";

const {
  API_GET_ADHOC_CLIENTS,

  API_GET_NOTICES,
  API_SEND_NOTICES,
  API_DELETE_CASES,
  API_DIS_APPROVE_NOTICES,
  API_GET_LOTS,
} = ApiUrl;

const NoticesAdhoc = (props) => {
  const ROLE = localStorage.getItem("role");
  const [noticesPage, setNoticesPage] = useState(0);
  const [noticesRowsPerPage, setNoticesRowsPerPage] = useState(20);
  const [noticesTotalCount, setNoticesTotalCount] = useState(0);
  const [ordersPage, setOrdersPage] = useState(0);
  const [ordersRowsPerPage, setOrdersRowsPerPage] = useState(20);
  const [ordersTotalCount, setOrdersTotalCount] = useState(0);
  const [certifiedPage, setCertifiedPage] = useState(0);
  const [certifiedRowsPerPage, setCertifiedRowsPerPage] = useState(20);
  const [certifiedTotalCount, setCertifiedTotalCount] = useState(0);
  const [lotsPage, setLotsPage] = useState(0);
  const [lotsRowsPerPage, setLotsRowsPerPage] = useState(20);
  const [lotsTotalCount, setLotsTotalCount] = useState(0);
  const [show, setShow] = useState(false);
  const [state, setState] = useState({
    temp: "",
    disabled: false,
  });
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [showVenue, setVenue] = useState(false);
  const [showpre, setShowPre] = useState(false);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [isCheckOrderAll, setIsCheckOrderAll] = useState(false);
  const [isCheckOrder, setIsCheckOrder] = useState([]);
  const [isCheckCertiAll, setIsCheckCertiAll] = useState(false);
  const [isCheckCerti, setIsCheckCerti] = useState([]);
  const [certifiedData, setCertified] = useState([]);
  const [orderData, setOrder] = useState([]);
  const [isNotice, setIsNotice] = useState({});
  const [list, setList] = useState([]);
  const [lots, setLots] = useState([]);
  const [temp, setTemp] = useState([]);
  const [open, setOpen] = useState(false);
  const [openSelect, setopenSelect] = useState(false);
  const [openConfirmation, setopenConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const clientDataRef = useRef([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState("All");
  const [currentActiveTab, setCurrentActiveTab] = useState("1");
  const [openRecipientSelect, setOpenRecipientSelect] = useState(false);
  const [counters, setCounters] = useState({
    certified: 0,
    notice: 0,
    order: 0,
    lot: 0
  });

  // const [formData, setFormData] = useState({
  //   whatsapp: false,
  //   email: false,
  //   sms: false,
  // });

  const [formData, setFormData] = useState([
    { type: 0, selected: false, whatsapp: false, sms: false, email: false }, // All
    { type: 1, selected: false, whatsapp: false, sms: false, email: false }, // Respondent
    { type: 2, selected: false, whatsapp: false, sms: false, email: false }, // Claimant
  ]);

  const [id, setId] = useState("");
  const [link, setLink] = useState();
  const docs = [
    {
      uri: link,
    },
  ];

  const unselectChecks = (tab) => {
    setIsCheck([]);
    setIsCheckOrder([]);
    setIsCheckCerti([]);
    setIsCheckAll(false);
    setIsCheckOrderAll(false);
    setIsCheckCertiAll(false);
  };

  // const toggle = (tab) => {
  //   if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  //   unselectChecks();
  //   if (tab === "4") {
  //     if (selectedClient === "All") {
  //       getLots();
  //     } else {
  //       const selectedClientData = clientDataRef.current.find(
  //         (client) => client.name === selectedClient
  //       );
  //       if (selectedClientData) {
  //         getLots(selectedClientData.id);
  //       }
  //     }
  //   }
  // };

  // const toggle = (tab) => {
  //   if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  //   unselectChecks();

  //   if (tab === "1") {
  //     if (selectedClient === "All") {
  //       getTableRecords();
  //     } else {
  //       const selectedClientData = clientDataRef.current.find(
  //         (client) => client.name === selectedClient
  //       );
  //       if (selectedClientData) {
  //         getTableRecords(selectedClientData.id);
  //       }
  //     }
  //   }

  //   if (tab === "2") {
  //     if (selectedClient === "All") {
  //       getTableOrders();
  //     } else {
  //       const selectedClientData = clientDataRef.current.find(
  //         (client) => client.name === selectedClient
  //       );
  //       if (selectedClientData) {
  //         getTableOrders(selectedClientData.id);
  //       }
  //     }
  //   }

  //   if (tab === "3") {
  //     if (selectedClient === "All") {
  //       getTableCertified();
  //     } else {
  //       const selectedClientData = clientDataRef.current.find(
  //         (client) => client.name === selectedClient
  //       );
  //       if (selectedClientData) {
  //         getTableCertified(selectedClientData.id);
  //       }
  //     }
  //   }

  //   if (tab === "4") {
  //     if (selectedClient === "All") {
  //       getLots();
  //     } else {
  //       const selectedClientData = clientDataRef.current.find(
  //         (client) => client.name === selectedClient
  //       );
  //       if (selectedClientData) {
  //         getLots(selectedClientData.id);
  //       }
  //     }
  //   }
  // };

  const toggle = (tab) => {
    if (currentActiveTab !== tab) {
      setCurrentActiveTab(tab);
      unselectChecks();

      setNoticesPage(0);
      setOrdersPage(0);
      setCertifiedPage(0);
      setLotsPage(0);

      if (tab === "1") {
        if (selectedClient === "All") {
          getTableRecords();
        } else {
          const selectedClientData = clientDataRef.current.find(
            (client) => client.name === selectedClient
          );
          if (selectedClientData) {
            getTableRecords(selectedClientData.id);
          }
        }
      }

      if (tab === "2") {
        if (selectedClient === "All") {
          getTableOrders();
        } else {
          const selectedClientData = clientDataRef.current.find(
            (client) => client.name === selectedClient
          );
          if (selectedClientData) {
            getTableOrders(selectedClientData.id);
          }
        }
      }

      if (tab === "3") {
        if (selectedClient === "All") {
          getTableCertified();
        } else {
          const selectedClientData = clientDataRef.current.find(
            (client) => client.name === selectedClient
          );
          if (selectedClientData) {
            getTableCertified(selectedClientData.id);
          }
        }
      }

      if (tab === "4") {
        if (selectedClient === "All") {
          getLots();
        } else {
          const selectedClientData = clientDataRef.current.find(
            (client) => client.name === selectedClient
          );
          if (selectedClientData) {
            getLots(selectedClientData.id);
          }
        }
      }
    }
  };

  const fetchClients = async () => {
    setLoading(true);
    try {
      const response = await Axios.get(`${API_URL}${API_GET_ADHOC_CLIENTS}`);

      console.log(">>>>>>>>>>>>>", response);

      const resData = response.data;
      if (response.status === 200) {
        clientDataRef.current = resData?.data;
      } else {
        toast.error(resData.error);
      }
    } catch (err) {
      console.log(err, "Error fetching clients");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  // const handleSelectClient = (clientName) => {
  //   setSelectedClient(clientName);
  //   setDropdownOpen(false);
  //   if (clientName === "All") {
  //     getTableRecords();
  //     getTableCertified();
  //     getTableOrders();
  //     getLots();
  //   } else {
  //     const selectedClient = clientDataRef.current.find((client) => client.name === clientName);
  //     if (selectedClient) {
  //       getTableRecords(selectedClient.id);
  //       getTableCertified(selectedClient.id);
  //       getTableOrders(selectedClient.id)
  //       getLots(selectedClient.id);
  //     }
  //   }
  // };

  const handleSelectClient = (clientName) => {
    setSelectedClient(clientName);
    setDropdownOpen(false);
    setNoticesPage(0);
    setOrdersPage(0);
    setCertifiedPage(0);
    setLotsPage(0);
    if (clientName === "All") {
      if (currentActiveTab === "1") getTableRecords();
      if (currentActiveTab === "2") getTableOrders();
      if (currentActiveTab === "3") getTableCertified();
      if (currentActiveTab === "4") getLots();
    } else {
      const selectedClient = clientDataRef.current.find((client) => client.name === clientName);
      if (selectedClient) {
        if (currentActiveTab === "1") getTableRecords(selectedClient.id);
        if (currentActiveTab === "2") getTableOrders(selectedClient.id);
        if (currentActiveTab === "3") getTableCertified(selectedClient.id);
        if (currentActiveTab === "4") getLots(selectedClient.id);
      }
    }
  };

  const getLots = async (clientId) => {
    setLoading(true);
    const apiUrl = clientId
      ? `${API_GET_LOTS}/${clientId}?limit=${lotsRowsPerPage}&page=${lotsPage + 1}`
      : `${API_GET_LOTS}?limit=${lotsRowsPerPage}&page=${lotsPage + 1}`;
    try {
      const response = await Axios.get(apiUrl);
      const resData = response.data;
      if (response.status === 200) {
        setLots(resData?.data);
        setLotsTotalCount(response.data.total);
        setCounters(resData.counter);
      } else {
        toast.error(resData.error);
      }
    } catch (err) {
      console.error("Error fetching lots:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleRecipientSubmit = (e) => {
    e.preventDefault();
    setOpenRecipientSelect(false);
    setopenSelect(true);
  };

  const handleRecipientHide = () => {
    setOpenRecipientSelect(false);
  };

  const handleCancel = () => {
    setShow(false);
  };

  const handleCancelPre = () => {
    setShowPre(false);
  };

  const handleShowPre = () => {
    setShowPre(true);
  };

  // const handleShow = () => {
  //   setopenSelect(true);
  // };

  const handleShow = () => {
    // setopenSelect(true);
    setOpenRecipientSelect(true);
  };

  const handleConfirmation = () => {
    setopenConfirmation(!openConfirmation);
  };

  const selectHide = () => {
    setopenSelect(false);
  };

  const handlePreview = (id) => {
    setShow(true);
  };

  // useEffect(() => {
  //   getTableRecords();
  //   getTableOrders();
  //   getTableCertified();
  // }, []);

  // useEffect(() => {
  //   if (currentActiveTab === "1") getTableRecords();
  //   if (currentActiveTab === "2") getTableOrders();
  //   if (currentActiveTab === "3") getTableCertified();
  //   if (currentActiveTab === "4") getLots();
  // }, [noticesPage, noticesRowsPerPage, ordersPage, ordersRowsPerPage, certifiedPage, certifiedRowsPerPage, lotsPage, lotsRowsPerPage, currentActiveTab]);

  useEffect(() => {
    if (currentActiveTab === "1") {
      if (selectedClient === "All") {
        getTableRecords();
      } else {
        const selectedClientData = clientDataRef.current.find(
          (client) => client.name === selectedClient
        );
        if (selectedClientData) {
          getTableRecords(selectedClientData.id);
        }
      }
    }
    if (currentActiveTab === "2") {
      if (selectedClient === "All") {
        getTableOrders();
      } else {
        const selectedClientData = clientDataRef.current.find(
          (client) => client.name === selectedClient
        );
        if (selectedClientData) {
          getTableOrders(selectedClientData.id);
        }
      }
    }
    if (currentActiveTab === "3") {
      if (selectedClient === "All") {
        getTableCertified();
      } else {
        const selectedClientData = clientDataRef.current.find(
          (client) => client.name === selectedClient
        );
        if (selectedClientData) {
          getTableCertified(selectedClientData.id);
        }
      }
    }
    if (currentActiveTab === "4") {
      if (selectedClient === "All") {
        getLots();
      } else {
        const selectedClientData = clientDataRef.current.find(
          (client) => client.name === selectedClient
        );
        if (selectedClientData) {
          getLots(selectedClientData.id);
        }
      }
    }
  }, [
    noticesPage,
    noticesRowsPerPage,
    ordersPage,
    ordersRowsPerPage,
    certifiedPage,
    certifiedRowsPerPage,
    lotsPage,
    lotsRowsPerPage,
    selectedClient,
  ]);

  const handleNoticesChangePage = (event, newPage) => {
    setNoticesPage(newPage);
  };

  const handleNoticesChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    const newTotalPages = Math.ceil(noticesTotalCount / newRowsPerPage) || 1;
    setNoticesRowsPerPage(newRowsPerPage);
    setNoticesPage(Math.min(noticesPage, Math.max(newTotalPages - 1, 0)));
  };

  const handleOrdersChangePage = (event, newPage) => {
    setOrdersPage(newPage);
  };

  const handleOrdersChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    const newTotalPages = Math.ceil(ordersTotalCount / newRowsPerPage) || 1;
    setOrdersRowsPerPage(newRowsPerPage);
    setOrdersPage(Math.min(ordersPage, Math.max(newTotalPages - 1, 0)));
  };

  const handleCertifiedChangePage = (event, newPage) => {
    setCertifiedPage(newPage);
  };

  const handleCertifiedChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    const newTotalPages = Math.ceil(certifiedTotalCount / newRowsPerPage) || 1;
    setCertifiedRowsPerPage(newRowsPerPage);
    setCertifiedPage(Math.min(certifiedPage, Math.max(newTotalPages - 1, 0)));
  };

  const handleLotsChangePage = (event, newPage) => {
    setLotsPage(newPage);
  };

  const handleLotsChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    const newTotalPages = Math.ceil(lotsTotalCount / newRowsPerPage) || 1;
    setLotsRowsPerPage(newRowsPerPage);
    setLotsPage(Math.min(lotsPage, Math.max(newTotalPages - 1, 0)));
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(list.map((li) => li.id));
    if (isCheckAll) {
      setIsCheck([]);
    }
    setState({ disabled: true });
  };

  const handleOrderAll = (e) => {
    console.log("order tab ");
    setIsCheckOrderAll(!isCheckOrderAll);
    setIsCheckOrder(orderData.map((li) => li.id));
    if (isCheckOrderAll) {
      setIsCheckOrder([]);
    }
    setState({ disabled: true });
  };

  const handleCertifiedAll = (e) => {
    console.log("certified tab");
    setIsCheckCertiAll(!isCheckCertiAll);
    setIsCheckCerti(certifiedData.map((li) => li.id));
    if (isCheckCertiAll) {
      setIsCheckCerti([]);
    }
    setState({ disabled: true });
  };

  const handleClick = (e, id) => {
    const isChecked = isCheck.includes(id);
    setState({ disabled: true });
    if (isChecked) {
      setIsCheck(isCheck.filter((item) => item !== id));
    } else {
      setIsCheck([...isCheck, id]);
    }
  };

  const handleClickOrder = (e, id) => {
    const isChecked = isCheckOrder.includes(id);
    setState({ disabled: true });
    if (isChecked) {
      setIsCheckOrder(isCheckOrder.filter((item) => item !== id));
    } else {
      setIsCheckOrder([...isCheckOrder, id]);
    }
  };

  const handleClickCerti = (e, id) => {
    console.log("ajkdhfkjhfa");
    const isChecked = isCheckCerti.includes(id);
    setState({ disabled: true });
    if (isChecked) {
      setIsCheckCerti(isCheckCerti.filter((item) => item !== id));
    } else {
      setIsCheckCerti([...isCheckCerti, id]);
    }
  };

  const getTableRecords = async (clientId = null) => {
    setLoading(true);
    try {
      const endpoint = clientId
        ? `${API_GET_NOTICES}/${clientId}?limit=${noticesRowsPerPage}&page=${noticesPage + 1}`
        : `${API_GET_NOTICES}?limit=${noticesRowsPerPage}&page=${noticesPage + 1}`;
      const response = await Axios.get(endpoint);
      const resData = response.data;
      if (response.status == 200) {
        const notices = resData?.data;
        setList(notices);
        setNoticesTotalCount(response.data.total);
        setCounters(resData.counter);
      } else {
        toast.error(resData.error);
      }
    } catch (err) {
      console.log(err, "wwwwwwwww");
    } finally {
      setLoading(false);
    }
  };

  const getTableOrders = async (clientId = null) => {
    setLoading(true);
    try {
      const endpoint = clientId
        ? `${API_GET_NOTICES}/${clientId}?type=order&limit=${ordersRowsPerPage}&page=${ordersPage + 1}`
        : `${API_GET_NOTICES}?type=order&limit=${ordersRowsPerPage}&page=${ordersPage + 1}`;
      const response = await Axios.get(endpoint);
      const resData = response.data;
      if (response.status == 200) {
        const order = resData?.data;
        setOrder(order);
        setOrdersTotalCount(response.data.total);
        setCounters(resData.counter);
      } else {
        toast.error(resData.error);
      }
    } catch (err) {
      console.log(err, "wwwwwwwww");
    } finally {
      setLoading(false);
    }
  };

  const getTableCertified = async (clientId = null) => {
    setLoading(true);
    try {
      const endpoint = clientId
        ? `${API_GET_NOTICES}/${clientId}?type=e-certified&limit=${certifiedRowsPerPage}&page=${certifiedPage + 1}`
        : `${API_GET_NOTICES}?type=e-certified&limit=${certifiedRowsPerPage}&page=${certifiedPage + 1}`;
      const response = await Axios.get(endpoint);
      const resData = response.data;
      if (response.status == 200) {
        const Ecertified = resData?.data;
        setCertified(Ecertified);
        setCertifiedTotalCount(response.data.total);
        setCounters(resData.counter);
      } else {
        toast.error(resData.error);
      }
    } catch (err) {
      console.log(err, "wwwwwwwww");
    } finally {
      setLoading(false);
    }
  };

  const refresh = () => {
    fetchClients();
    if (selectedClient === "All") {
      getTableRecords();
      getTableCertified()
      getTableOrders();
      getLots();
    } else {
      const selectedClientData = clientDataRef.current.find(
        (client) => client.name === selectedClient
      );
      if (selectedClientData) {
        getTableRecords(selectedClientData.id);
        getTableCertified(selectedClientData.id);
        getTableOrders(selectedClientData.id);
        getLots(selectedClientData.id);
      }
    }
  };

  // const handleSubmit = async () => {
  //   setLoading(true);
  //   let data = {
  //     document_ids:
  //       currentActiveTab == 1
  //         ? isCheck
  //         : currentActiveTab == 2
  //           ? isCheckOrder
  //           : isCheckCerti,
  //     whatsapp: formData.whatsapp,
  //     sms: formData.sms,
  //     email: formData.email,
  //   };
  //   Axios.Post(API_SEND_NOTICES, data)
  //     .then((res) => {
  //       let response = res.data;
  //       if (response.status == 200) {
  //         toast.success(response.message);
  //         setLoading(false);
  //         setopenSelect(false);
  //       } else {
  //         toast.error(response.message);
  //       }
  //     })
  //     .catch((error) => {
  //       let res = error.response;
  //     });
  // };

  const handleSubmit = async () => {
    setLoading(true);
    const recipients = formData
      .filter((recipient) => recipient.selected && (recipient.whatsapp || recipient.sms || recipient.email))
      .map(({ type, whatsapp, sms, email }) => ({
        type,
        whatsapp,
        sms,
        email,
      }));

    let data = {
      document_ids:
        currentActiveTab === "1"
          ? isCheck
          : currentActiveTab === "2"
            ? isCheckOrder
            : isCheckCerti,
      recipients: recipients.length > 0 ? recipients : undefined,
    };

    try {
      const res = await Axios.post(API_SEND_NOTICES, data);
      const response = res.data;
      if (response.status === 200) {
        toast.success(response.message);
        setLoading(false);
        setOpenRecipientSelect(false);
        setopenSelect(false);
        refresh();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error sending notices:", error);
      toast.error("Failed to send notices.");
    } finally {
      setLoading(false);
    }
  };

  // const handleUpload = async () => {
  //   let data = {
  //     document_ids: currentActiveTab == 1 ? isCheck : isCheckOrder,
  //   };

  //   Axios.Post(API_SEND_NOTICES, data)
  //     .then((res) => {
  //       let response = res.data;
  //       if (response.success == true) {
  //         toast.success(response.message);
  //       } else {
  //         toast.error(response.error);
  //       }
  //     })
  //     .catch((error) => {
  //       let res = error.response;
  //     });
  // };

  const handleUpload = async () => {
    let data = {
      document_ids: currentActiveTab == 1 ? isCheck : isCheckOrder,
      recipients: [
        {
          type: 0,
          whatsapp: false,
          sms: false,
          email: false,
        },
      ],
    };

    Axios.Post(API_SEND_NOTICES, data)
      .then((res) => {
        let response = res.data;
        if (response.success == true) {
          toast.success(response.message);
          refresh();
        } else {
          toast.error(response.error);
        }
      })
      .catch((error) => {
        let res = error.response;
      });
  };

  const disApproveNotice = async () => {
    let data = {
      document_ids: currentActiveTab == 1 ? isCheck : currentActiveTab == 2 ? isCheckOrder : isCheckCerti,
    };
    Axios.Post(API_DIS_APPROVE_NOTICES, data)
      .then((res) => {
        let response = res.data;
        if (response.success == true) {
          toast.success(response.message);
          setOpen(false);
          refresh();
        } else {
          toast.error(response.error);
        }
      })
      .catch((error) => {
        let res = error.response;
      });
  };

  // const handleRadio = (e) => {
  //    const {checked,value} = e.target
  //   console.log(checked,value, "e.target");
  //   setIsNotice(value);
  //   if (!checked) {
  //     setIsNotice(isNotice.filter((item) => item !== value));
  //   }
  // };

  // const handleRadio = (e) => {
  //   const { name, value } = e.target;
  //   console.log(name, value, "e.target");
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));
  //   setChecked(!checked);
  // };

  // const handleRadio = (e) => {
  //   const { name, checked } = e.target;
  //   console.log(name, "e.target");
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     [name]: checked,
  //   }));
  //   setChecked(!checked);
  // };

  const handleRadio = (e) => {
    const { name, checked } = e.target;
    const typeMap = { All: 0, Respondent: 1, Claimant: 2 };

    if (name.includes("-")) {
      // Handle communication method checkboxes
      const [recipientType, method] = name.split("-"); // e.g., "All-whatsapp" -> ["All", "whatsapp"]
      setFormData((prevState) =>
        prevState.map((recipient) =>
          recipient.type === typeMap[recipientType]
            ? { ...recipient, [method]: checked }
            : recipient
        )
      );
    } else {
      // Handle recipient selection checkbox
      setFormData((prevState) =>
        prevState.map((recipient) =>
          recipient.type === typeMap[name]
            ? { ...recipient, selected: checked }
            : recipient
        )
      );
    }
    setChecked(true);
  };

  const deleteAction = (id) => {
    Axios.post(API_DELETE_CASES + id)
      .then((res) => {
        setOpen(false);
        toast.success(res.data.message);
      })
      .catch((err) => {
        setOpen(false);
        toast.success("Cases does not deleted!");
      });
  };

  const downloadFile = async (id, name) => {
    try {
      const url = `${API_URL}${API_VERSION}/get-file/link/${id}`;
      const response = await fetch(url);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const previewFile = async (id) => {
    try {
      const url = `${API_URL}${API_VERSION}/get-file/link/${id}`;
      const response = await fetch(url);
      console.log(response, "response123");
      setLink(response.url);
      const blob = await response.blob();
      const urlObject = window.URL.createObjectURL(blob);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
    setShowPre(true);
  };

  const toggleRev1 = (index) => {
    setVenue((prev) => (prev === index ? null : index));
  };

  const cataloge =
    list &&
    list?.length > 0 &&
    list?.map((item, index) => {
      return (
        <div className="timline-content">
          {/* <div class="px-1 time-name d-flex justify-content-between">
            <div class="d-flex">
              <span>
                <Checkbox
                  key={item.id}
                  type="checkbox"
                  name={item.label}
                  id={item.id}
                  handleClick={handleClick}
                  isChecked={isCheck.includes(item.id)}
                />
              </span>
            </div>
          </div> */}

          <div className=" ">
            <Row>
              {/* <Col md="1">
                <span>
                  <Checkbox
                    key={item.id}
                    type="checkbox"
                    name={item.label}
                    id={item.id}
                    isChecked={isCheck.includes(item.id)}
                    handleClick={(e) => handleClick(e, item.id)}
                    // handleClick={handleClick}
                  />
                </span>
              </Col> */}
              <Col md="12">
                {/* <div className="notice-container">
                  <div className="">
                    <p className="notices-heading">
                      <font>Notice Name: </font>
                    </p>
                    <p className="">{item?.media?.name || "--"}</p>
                  </div>
                  <div className=" ">
                    <p className="notices-heading">
                      <font>Notice Type: </font>
                    </p>
                    <p className="">{item?.type || "--"}</p>
                  </div>
                  <div className=" ">
                    <p className="notices-heading">
                      <font>Date: </font>
                    </p>
                    <p className="">
                      {moment(item?.created_at).format("LLL") || "--"}
                    </p>
                  </div>
                </div> */}

                <Card className="m-0">
                  <div>
                    <CardText>
                      <span>
                        <Checkbox
                          key={item.id}
                          type="checkbox"
                          name={item.label}
                          id={item.id}
                          isChecked={isCheck.includes(item.id)}
                          handleClick={(e) => handleClick(e, item.id)}
                        // handleClick={handleClick}
                        />
                      </span>
                    </CardText>
                  </div>
                  <CardBody className="row text-left py-0">
                    <CardText className="col-sm-4">
                      <b>Client </b>:{" "}
                      {item?.bulk_case_relation &&
                        item?.bulk_case_relation[0].related_user.name}
                      {/* {item?.bulk_case_relation &&
                        item?.bulk_case_relation.map((i) => {
                          return <>{i.related_user?.name || ""}</>;
                        })} */}
                    </CardText>
                    <CardText className="col-sm-4">
                      <b>Name </b>: {item?.media?.alt || ""}
                    </CardText>
                    <CardText className="col-sm-4">
                      <b>File </b>: {item?.media?.name || "--"}
                    </CardText>
                    <CardText className="col-sm-4">
                      <b>Notice Type </b>: {item?.type || "--"}
                    </CardText>
                    <CardText className="col-sm-4">
                      <b>Created By </b>: {item?.role?.name || "--"}
                    </CardText>
                    <CardText className="col-sm-4">
                      <b>Date </b>:{" "}
                      {moment(item?.created_at).format("DD.MM.YYYY") || "--"}
                    </CardText>
                    <CardText className="col-sm-8">
                      <b>Description </b>: {item?.media?.description || "--"}
                    </CardText>
                    <CardText className="col-sm-2">
                      <span
                        className="preview-pdf3"
                        onClick={() => previewFile(item?.media?.hash_id)}
                      >
                        Preview Pdf
                      </span>
                    </CardText>
                    <CardText className="col-sm-2">
                      <i
                        className="zmdi zmdi-download"
                        onClick={() =>
                          downloadFile(
                            item?.media?.hash_id,
                            item?.media?.alt + "_" + item?.media?.name
                          )
                        }
                        style={{ fontSize: "25px", cursor: "pointer" }}
                      ></i>
                    </CardText>
                  </CardBody>
                </Card>

                {/* <div className="filesrevenue-subconatiner">
                  <div className="pov123">
                    <p>
                      <span className="pov123Text">Client:</span>
                      {item?.media?.alt || ""}
                    </p>
                    <p>
                      <span className="pov123Text">Name:</span>
                      {item?.media?.alt || ""}
                    </p>
                    <p>
                      <span className="pov123Text">File:</span>
                      {item?.media?.name || "--"}
                    </p>
                    <p className="text-capitalize">
                      <span className="pov123Text">Notice Type:</span>
                      {item?.type || "--"}
                    </p>
                    <p className="text-capitalize">
                      <span className="pov123Text">Created By:</span>
                      {item?.media?.uploaded_by || "--"}
                    </p>
                    <p>
                      <span className="pov123Text">Date:</span>
                      {moment(item?.created_at).format("LLL") || "--"}
                    </p>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center py-2">
                  <div className="">
                    <div className="d-flex mt-2">
                      <p className="des-908">
                        <span className="pov123Text">Description:</span>
                        {item?.media?.description || "--"}
                      </p>
                    </div>
                  </div>
                </div> */}
              </Col>
            </Row>
          </div>
        </div>
      );
    });

  const certified =
    certifiedData &&
    certifiedData?.length > 0 &&
    certifiedData?.map((item, index) => {
      return (
        <div className="timline-content">
          <div className=" ">
            <Row>
              <Col md="1">
                <span>
                  <Checkbox
                    key={item.id}
                    type="checkbox"
                    name={item.label}
                    id={item.id}
                    isChecked={isCheckCerti.includes(item.id)}
                    handleClick={(e) => handleClickCerti(e, item.id)}
                  />
                </span>
              </Col>
              <Col md="11">
                <Card className="m-0">
                  <CardBody className="row text-left">
                    <CardText className="col-sm-4">
                      <b>Client </b>:{" "}
                      {item?.bulk_case_relation &&
                        item?.bulk_case_relation[0].related_user.name}
                    </CardText>
                    <CardText className="col-sm-4">
                      <b>Name </b>: {item?.media?.alt || ""}
                    </CardText>
                    <CardText className="col-sm-4">
                      <b>File </b>: {item?.media?.name || "--"}
                    </CardText>
                    <CardText className="col-sm-4">
                      <b>Notice Type </b>: {item?.type || "--"}
                    </CardText>
                    <CardText className="col-sm-4">
                      <b>Created By </b>: {item?.role?.name || "--"}
                    </CardText>
                    <CardText className="col-sm-4">
                      <b>Date </b>:{" "}
                      {moment(item?.created_at).format("DD.MM.YYYY") || "--"}
                    </CardText>
                    <CardText className="col-sm-8">
                      <b>Description </b>: {item?.media?.description || "--"}
                    </CardText>
                    <CardText className="col-sm-2">
                      <span
                        className="preview-pdf3"
                        onClick={() => previewFile(item?.media?.hash_id)}
                      >
                        Preview Pdf
                      </span>
                    </CardText>
                    <CardText className="col-sm-2">
                      <i
                        className="zmdi zmdi-download"
                        onClick={() =>
                          downloadFile(
                            item?.media?.hash_id,
                            item?.media?.alt + "_" + item?.media?.name
                          )
                        }
                        style={{ fontSize: "25px", cursor: "pointer" }}
                      ></i>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      );
    });

  const orderTab =
    orderData &&
    orderData?.length > 0 &&
    orderData?.map((item, index) => {
      return (
        <div className="timline-content">
          <div className=" ">
            <Row>
              <Col md="1">
                <span>
                  <Checkbox
                    key={item.id}
                    type="checkbox"
                    name={item.label}
                    id={item.id}
                    isChecked={isCheckOrder.includes(item.id)}
                    handleClick={(e) => handleClickOrder(e, item.id)}
                  />
                </span>
              </Col>
              <Col md="11">
                <Card className="m-0">
                  <CardBody className="row text-left">
                    <CardText className="col-sm-4">
                      <b>Client </b>:{" "}
                      {item?.bulk_case_relation &&
                        item?.bulk_case_relation[0].related_user.name}
                    </CardText>
                    <CardText className="col-sm-4">
                      <b>Name </b>: {item?.media?.alt || ""}
                    </CardText>
                    <CardText className="col-sm-4">
                      <b>File </b>: {item?.media?.name || "--"}
                    </CardText>
                    <CardText className="col-sm-4">
                      <b>Notice Type </b>: {item?.type || "--"}
                    </CardText>
                    <CardText className="col-sm-4">
                      <b>Created By </b>: {item?.role?.name || "--"}
                    </CardText>
                    <CardText className="col-sm-4">
                      <b>Date </b>:{" "}
                      {moment(item?.created_at).format("DD.MM.YYYY") || "--"}
                    </CardText>
                    <CardText className="col-sm-8">
                      <b>Description </b>: {item?.media?.description || "--"}
                    </CardText>
                    <CardText className="col-sm-2">
                      <span
                        className="preview-pdf3"
                        onClick={() => previewFile(item?.media?.hash_id)}
                      >
                        Preview Pdf
                      </span>
                    </CardText>
                    <CardText className="col-sm-2">
                      <i
                        className="zmdi zmdi-download"
                        onClick={() =>
                          downloadFile(
                            item?.media?.hash_id,
                            item?.media?.alt + "_" + item?.media?.name
                          )
                        }
                        style={{ fontSize: "25px", cursor: "pointer" }}
                      ></i>
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      );
    });

  const lotsData =
    lots &&
    lots?.length > 0 &&
    lots?.map((item, index) => {
      return (
        <div className="timline-content c-pointer">
          <div className=" ">
            <Row>
              <Col md="12">
                <Card className="m-0">
                  <Link
                    to={{
                      pathname: `/app/lawfirm/notices/lot`,
                      state: { id: item.id }
                    }}
                    style={{ color: "#777" }}
                  >
                    <CardBody className="row text-left p-1">
                      <CardText className="col-sm-4 lot-name">
                        <b>Name </b>: <span>{item?.name || ""}</span>
                      </CardText>
                      <CardText className="col-sm-4">
                        <b>Created By </b>: {item?.created_by?.name}
                      </CardText>

                      <CardText className="col-sm-4">
                        <b>Date </b>:{" "}
                        {moment(item?.created_at).format("DD.MM.YYYY") || "--"}
                      </CardText>
                    </CardBody>
                  </Link>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      );
    });

  return (
    <section className="Sales_analytics" style={{ paddingBottom: "42px" }}>
      <DialogBox
        title={"Notice"}
        open={open}
        onClose={handleClose}
        deleteAction={disApproveNotice}
      />
      <div fluid>
        <Row>
          {/* <Link
            to="/app/client/list"
            style={{
              color: "grey",
              fontSize: "32px",
            }}
          >
            <i
              class="zmdi zmdi-arrow-left"
              style={{ fontSize: "22px", marginTop: "2px" }}
            ></i>
          </Link> */}
          <Col md="3" xs="12"></Col>
          {ROLE !== "Secretariat-L3" && (
            <Col md="9" xs="12" style={{ marginTop: '-11px' }}>
              <div>
                <Tooltip title="Need to select notice" arrow>
                  <Button
                    className={
                      isCheck.length > 0 ||
                        isCheckCerti.length > 0 ||
                        isCheckOrder.length > 0
                        ? "float-right mt-4 mr-5"
                        : "float-right mt-4 mr-5 generate-disabled"
                    }
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={state.disabled == true ? handleShow : ""}
                  >
                    Approve & Send
                  </Button>
                </Tooltip>
                <Tooltip title="Need to select notice" arrow>
                  <Button
                    className={
                      isCheck.length > 0 || isCheckOrder.length > 0
                        ? "float-right mt-4 mr-5"
                        : "float-right mt-4 mr-5 generate-disabled"
                    }
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={state.disabled == true ? handleUpload : ""}
                  >
                    Approve & Upload
                  </Button>
                </Tooltip>
                <Tooltip title="Need to select notice" arrow>
                  <Button
                    className={
                      isCheck.length > 0 ||
                        isCheckCerti.length > 0 ||
                        isCheckOrder.length > 0
                        ? "float-right mt-4 mr-5"
                        : "float-right mt-4 mr-5 generate-disabled"
                    }
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={state.disabled == true ? handleClickOpen : ""}
                  >
                    Disapprove Notices
                  </Button>
                </Tooltip>

                {/* <form onSubmit={handleSubmit}>
                  <Menu
                    id="simple-menu"
                    anchorEl={openSelect}
                    keepMounted
                    open={openSelect}
                    onClose={selectHide}
                    className="notices-select12"
                    anchorOrigin={{
                      horizontal: "right",
                    }}
                    PaperProps={{
                      style: {
                        transform: "translateX(-50px) translateY(-58px)",
                        width: "250px",
                        display: "flex",
                      },
                    }}
                    MenuListProps={{
                      style: {
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        margin: "5px",
                      },
                    }}
                  >
                    <MenuItem>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value="whatsapp"
                          checked={formData.whatsapp}
                          name={"whatsapp"}
                          onChange={handleRadio}
                        />
                        <label class="form-check-label" for="flexCheckChecked">
                          Whats App
                        </label>
                      </div>
                    </MenuItem>
                    <MenuItem>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value="sms"
                          checked={formData.sms}
                          name={"sms"}
                          onChange={handleRadio}
                        />
                        <label class="form-check-label" for="flexCheckChecked">
                          SMS
                        </label>
                      </div>
                    </MenuItem>
                    <MenuItem>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value="email"
                          checked={formData.email}
                          name={"email"}
                          onChange={handleRadio}
                        />
                        <label class="form-check-label" for="flexCheckChecked">
                          Mail
                        </label>
                      </div>
                    </MenuItem>
                    <Row>
                      <Col md={3}>
                        <Button type="submit" onClick={handleSubmit}>
                          Send
                        </Button>
                      </Col>
                    </Row>
                  </Menu>
                </form> */}

                <form onSubmit={handleRecipientSubmit}>
                  <Menu
                    id="recipient-menu"
                    anchorEl={openRecipientSelect}
                    keepMounted
                    open={openRecipientSelect}
                    onClose={handleRecipientHide}
                    className="notices-select12"
                    anchorOrigin={{
                      horizontal: "right",
                    }}
                    PaperProps={{
                      style: {
                        width: "fit-content",
                        padding: "0px 10px",
                        marginLeft: "-80px",
                        marginTop: "-87px",
                      },
                    }}
                    MenuListProps={{
                      style: {
                        width: "fit-content",
                        display: "grid",
                        gridTemplateColumns: "repeat(1, 1fr)",
                        margin: "5px",
                        paddingRight: "1.25rem",
                      },
                    }}
                  >
                    {["All", "Respondent", "Claimant"].map((recipientType, index) => (
                      <MenuItem key={recipientType}>
                        <div className="form-check">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name={recipientType}
                              checked={formData[index].selected}
                              onChange={handleRadio}
                            />
                            <label className="form-check-label">{recipientType}</label>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div className="form-check" style={{ marginLeft: "20px" }}>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name={`${recipientType}-whatsapp`}
                                checked={formData[index].whatsapp}
                                onChange={handleRadio}
                                disabled={!formData[index].selected}
                              />
                              <label className="form-check-label">WhatsApp</label>
                            </div>
                            <div className="form-check" style={{ marginLeft: "20px" }}>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name={`${recipientType}-sms`}
                                checked={formData[index].sms}
                                onChange={handleRadio}
                                disabled={!formData[index].selected}
                              />
                              <label className="form-check-label">SMS</label>
                            </div>
                            <div className="form-check" style={{ marginLeft: "20px" }}>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name={`${recipientType}-email`}
                                checked={formData[index].email}
                                onChange={handleRadio}
                                disabled={!formData[index].selected}
                              />
                              <label className="form-check-label">Mail</label>
                            </div>
                          </div>
                        </div>
                      </MenuItem>
                    ))}
                    <Row style={{ justifyContent: "end", marginTop: "10px" }}>
                      <Col md={3}>
                        <Button type="submit" onClick={handleSubmit}>
                          Send
                        </Button>
                      </Col>
                    </Row>
                  </Menu>
                </form>

              </div>
            </Col>
          )}
        </Row>

        <div className="revenueTable-conatiner mt-2">
          <div className="revenueTable-pagination-box">
            <div className="pgination-1st">
              {" "}
              <span className="check-po-icon">
                {currentActiveTab == 1 && (
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="flexCheckDefault"
                      onChange={handleSelectAll}
                      isChecked={isCheckAll}
                    />
                  </div>
                )}
                {currentActiveTab == 2 && (
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="flexCheckDefault"
                      onChange={handleOrderAll}
                      isChecked={isCheckOrderAll}
                    />
                  </div>
                )}
                {currentActiveTab == 3 && (
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="flexCheckDefault"
                      onChange={handleCertifiedAll}
                      isChecked={isCheckCertiAll}
                    />
                  </div>
                )}
              </span>
              <span className="check-po-icon" onClick={refresh}>
                <i class="zmdi zmdi-refresh-alt"></i>
              </span>
              {/* <span className="check-po-icon" onClick={handleClickOpen}>
                <i class="zmdi zmdi-delete"></i>
              </span> */}
              {/* <span className="check-po-icon" onClick={handlePreview}>
                <i class="zmdi zmdi-filter-b-and-w"></i>
              </span> */}
            </div>
            {/* <div className="pagination-conatinerw">
              <div className="d-flex pagination-text justify-content-end">
                <span className="pto-5">Show</span>
                <select
                  class="form-select page-select12"
                  aria-label="Default select example"
                  onChange={(event) => setLimit(event.target.value)}
                >
                  <option selected>20</option>
                  <option value="50">50</option>
                  <option value="80">80</option>
                  <option value="100">100</option>
                  <option value={list && list?.length}>
                    {list && list?.length}
                  </option>
                </select>
                <span className="pto-5">
                  {" "}
                  per page from
                  {currentActiveTab == 1
                    ? list && list?.length
                    : currentActiveTab == 2
                      ? orderData && orderData?.length
                      : currentActiveTab == 3
                        ? certifiedData && certifiedData?.length
                        : certifiedData && certifiedData?.length}{" "}
                  results{" "}
                </span>
              </div>
            </div> */}
          </div>

          <div className="mt-2">
            <Nav tabs>
              <div>
                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                  <DropdownToggle caret>
                    {selectedClient}
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem onClick={() => handleSelectClient("All")}>All</DropdownItem>
                    {clientDataRef.current.map((client) => (
                      <DropdownItem
                        key={client.id}
                        onClick={() => handleSelectClient(client.name)}
                      >
                        {client.name}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </div>

              <NavItem>
                <NavLink
                  className={classnames({
                    active: currentActiveTab === "1",
                  })}
                  onClick={() => {
                    toggle("1");
                  }}
                >
                  Notices
                  {/* {list && list?.length > 0 && ( */}
                  <>
                    <span className="approval-notif-count">
                      {counters.notice}
                    </span>
                  </>
                  {/* )} */}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: currentActiveTab === "2",
                  })}
                  onClick={() => {
                    toggle("2");
                  }}
                >
                  Orders
                  {/* {orderData && orderData?.length > 0 && ( */}
                  <>
                    <span className="approval-notif-count">
                      {counters.order}
                    </span>
                  </>
                  {/* )} */}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: currentActiveTab === "3",
                  })}
                  onClick={() => {
                    toggle("3");
                  }}
                >
                  E-Certified
                  {/* {certifiedData && certifiedData?.length > 0 && ( */}
                  <>
                    {/* <span>
                        <img src={tingtong} style={{ width: "20px" }} />
                      </span> */}
                    <span className="approval-notif-count">
                      {counters.certified}
                    </span>
                  </>
                  {/* )} */}
                </NavLink>
              </NavItem>
              
              {/* <NavItem>
                <NavLink
                  className={classnames({
                    active: currentActiveTab === "4",
                  })}
                  onClick={() => {
                    toggle("4");
                  }}
                >
                  Lot Wise
                  <>
                    <span className="approval-notif-count">
                      {counters.lot}
                    </span>
                  </>
                </NavLink>
              </NavItem> */}
              
            </Nav>
          </div>

          <div className="revenue-scroll-container">

            <TabContent activeTab={currentActiveTab}>
              <TabPane tabId="1">
                {loading === false && list && list?.length === 0 && (
                  <div className="n--data text-center m-5">No data Found!</div>
                )}
                {loading === true && (
                  <div className="n--data text-center m-5">
                    <Loading />
                  </div>
                )}
                {cataloge}
              </TabPane>
            </TabContent>

            <TabContent activeTab={currentActiveTab}>
              <TabPane tabId="2">
                {loading === true ? (
                  <div className="n--data text-center m-5">
                    <Loading />
                  </div>
                ) : orderData && orderData.length === 0 ? (
                  <div className="n--data text-center m-5">No data Found!</div>
                ) : (
                  orderTab
                )}
              </TabPane>
            </TabContent>

            <TabContent activeTab={currentActiveTab}>
              <TabPane tabId="3">
                {loading === true ? (
                  <div className="n--data text-center m-5">
                    <Loading />
                  </div>
                ) : certifiedData && certifiedData.length === 0 ? (
                  <div className="n--data text-center m-5">No data Found!</div>
                ) : (
                  certified
                )}
              </TabPane>
            </TabContent>

            <TabContent activeTab={currentActiveTab}>
              <TabPane tabId="4">
                {loading === true ? (
                  <div className="n--data text-center m-5">
                    <Loading />
                  </div>
                ) : lots && lots.length === 0 ? (
                  <div className="n--data text-center m-5">No data Found!</div>
                ) : (
                  lotsData
                )}
              </TabPane>
            </TabContent>
          </div>

          {list && list.length > 0 && currentActiveTab == 1 && (
            <div className="float-right">
              <DataTablePagination
                count={noticesTotalCount}
                rowsPerPage={noticesRowsPerPage}
                page={noticesPage}
                onChangePage={handleNoticesChangePage}
                onChangeRowsPerPage={handleNoticesChangeRowsPerPage}
                rowsPerPageOptions={[20, 50, 100, 200]}
              />
            </div>
          )}

          {orderData && orderData.length > 0 && currentActiveTab == 2 && (
            <div className="float-right">
              <DataTablePagination
                count={ordersTotalCount}
                rowsPerPage={ordersRowsPerPage}
                page={ordersPage}
                onChangePage={handleOrdersChangePage}
                onChangeRowsPerPage={handleOrdersChangeRowsPerPage}
                rowsPerPageOptions={[20, 50, 100, 200]}
              />
            </div>
          )}

          {certifiedData && certifiedData.length > 0 && currentActiveTab == 3 && (
            <div className="float-right">
              <DataTablePagination
                count={certifiedTotalCount}
                rowsPerPage={certifiedRowsPerPage}
                page={certifiedPage}
                onChangePage={handleCertifiedChangePage}
                onChangeRowsPerPage={handleCertifiedChangeRowsPerPage}
                rowsPerPageOptions={[20, 50, 100, 200]}
              />
            </div>
          )}

          {lots && lots.length > 0 && currentActiveTab == 4 && (
            <div className="float-right">
              <DataTablePagination
                count={lotsTotalCount}
                rowsPerPage={lotsRowsPerPage}
                page={lotsPage}
                onChangePage={handleLotsChangePage}
                onChangeRowsPerPage={handleLotsChangeRowsPerPage}
                rowsPerPageOptions={[20, 50, 100, 200]}
              />
            </div>
          )}

        </div>
      </div>

      <Modal isOpen={show} toggle={handleCancel}>
        <p className="text-right m-0">
          <span onClick={handleCancel} className="modal-cancel12">
            <i class="zmdi zmdi-close"></i>
          </span>
        </p>
        <ModalBody>
          <p className="modal-case-12-heading">Case Limitation</p>
          <form>
            <Row>
              <Col md="4" xs="12">
                <SELECT
                  label="Chamber of arbitration"
                  name={"role"}
                  // value={role}
                  // onChange={handleChange}
                  data={[{ 1: "Active" }, { 0: "In Active" }]}
                />
              </Col>
              <Col md="4" xs="12">
                <SELECT
                  label="Source Law Firm"
                  name={"status"}
                  // value={status}
                  // onChange={handleChange}
                  data={[{ 1: "Active" }, { 0: "In Active" }]}
                />
              </Col>
              <Col md="4" xs="12">
                <SELECT
                  label="Arbitrator"
                  name={"status"}
                  // value={status}
                  // onChange={handleChange}
                  data={[{ 1: "Active" }, { 0: "In Active" }]}
                />
              </Col>
              <Col md="4" xs="12">
                <SELECT
                  label="Arbitrator"
                  name={"status"}
                  // value={status}
                  // onChange={handleChange}
                  data={[{ 1: "Active" }, { 0: "In Active" }]}
                />
              </Col>
            </Row>
          </form>
        </ModalBody>
      </Modal>
      <Modal isOpen={showpre} toggle={handleCancelPre}>
        <p className="text-right m-0">
          <span onClick={handleCancelPre} className="modal-cancel12">
            <i class="zmdi zmdi-close"></i>
          </span>
        </p>
        <ModalBody>
          <DocViewer pluginRenderers={DocViewerRenderers} documents={docs} />
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={openConfirmation} toggle={handleConfirmation}>
        <p className="text-right m-0">
          <span onClick={handleConfirmation} className="modal-cancel12">
            <i class="zmdi zmdi-close"></i>
          </span>
        </p>

        <ModalBody>
          <p className="modal-case-12-heading">
            Notice disapprove confirmation
          </p>
          <p>Choose "No" to prevent the action, Choose "Yes" to take action.</p>
          <div className="float-right">
            <button onClick={disApproveNotice} className="yes-no-09">
              Yes
            </button>
            <button onClick={handleConfirmation} className="yes-no-09">
              No
            </button>
          </div>
        </ModalBody>
      </Modal>
    </section>
  );
};

export default NoticesAdhoc;